import React, { useRef, useState, useContext } from "react";
import PropTypes from "prop-types";
import { CredsContext, HelpModeContext } from "./Contexts";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DashboardPanelHeader from "./DashboardPanelHeader";
import StatusProjectMetricsBigNumbers from "./StatusProjectMetricsBigNumbers";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Tools from "./JNSTools";
import "./styles/DashboardProjectMetrics.css";

function DashboardProjectMetricsBigNumbers(props) {
  //const projectObject = useRef(
  //  JSON.parse(sessionStorage.getItem("projectObject")),
  //);
  const creds = useContext(CredsContext).creds;
  const [metricState, setMetricState] = useState(props.metric);
  const [editPctComplete, setEditPctComplete] = useState(false);

  const helpMode = useContext(HelpModeContext).mode;
  const showBilling =
    props.projectObject.oada_project_show_billing__c == 1 ? true : false;

  const metrics = Tools.calculateProjectMetrics(props.projectObject, creds);
  const metricsObject = {};

  const moneyConfig = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });

  metricsObject.actualValue =
    metricState == "money"
      ? moneyConfig.format(metrics.actualMoney)
      : metrics.actualHours;
  metricsObject.etcValue =
    metricState == "money"
      ? moneyConfig.format(metrics.etcMoney)
      : metrics.estimateToCompletion; // was etcHours
  metricsObject.eacValue =
    metricState == "money"
      ? moneyConfig.format(metrics.eacMoney)
      : metrics.estimateAtCompletion; // was eacHours
  metricsObject.budgetValue =
    metricState == "money"
      ? moneyConfig.format(metrics.budgetMoney)
      : metrics.budgetHours;
  metricsObject.diffValue =
    metricState == "money"
      ? moneyConfig.format(
          Math.round((metrics.budgetMoney - metrics.eacMoney) * 100) / 100,
        )
      : Math.round(
          (parseFloat(metricsObject.budgetValue) -
            parseFloat(metricsObject.eacValue)) *
            100,
        ) / 100;
  metricsObject.pctComplete = parseFloat(
    props.projectObject.oada_project_pct_complete__c,
  );

  metricsObject.suffix = metricState == "money" ? null : " Hours";
  let pctInput;

  const handleClick = () => {
    if (metricState == "money") {
      setMetricState("hours");
    } else if (showBilling) {
      setMetricState("money");
    }
  };

  const handlePctCompleteClick = () => {
    if (!editPctComplete) {
      setEditPctComplete(true);
    }
  };

  const savePctComplete = () => {
    if (
      creds.projectRole == "F" &&
      pctInput.value &&
      parseFloat(pctInput.value) !=
        parseFloat(props.projectObject.oada_project_pct_complete__c)
    ) {
      props.projectObject.oada_project_pct_complete__c = pctInput.value;
      sessionStorage.setItem(
        "projectObject",
        JSON.stringify(props.projectObject),
      );
      const authString = Tools.getXmlBodyAuthString(creds);
      const urlString = Tools.getInstanceUrl(creds);
      const updateString =
        authString +
        '<Modify type="Project" enable_custom="1"><Project><id>' +
        props.projectObject.id +
        "</id><oada_project_pct_complete__c>" +
        Math.round(pctInput.value * 100) / 100 +
        "</oada_project_pct_complete__c></Project></Modify></request>";
      Tools.fetchPost(updateString, urlString);
    }
    setEditPctComplete(false);
  };
  if (props.statusVersion) {
    return (
      <Box>
        <StatusProjectMetricsBigNumbers metricsObject={metricsObject} />
      </Box>
    );
  } else {
    return (
      <>
        <Box
          height="20%"
          className="dashTableTitleBar"
          sx={{ backgroundColor: "transparent" }}
        >
          <DashboardPanelHeader
            panelLocked={props.panelLocked}
            //title="Links"
            removePanel={props.removePanel}
            panelId={props.panelId}
            //headerComponent={addLinkComponent}
          />
        </Box>
        <Box height="75%" margin="0px" padding="0px">
          <Table>
            <TableBody>
              <TableRow>
                <TableCell
                  onClick={helpMode ? null : handleClick}
                  id={
                    metricState == "hours"
                      ? "__dashboardProjectMetricsActualHours"
                      : "__dashboardProjectMetricsActualMoney"
                  }
                  className="bigNumbersCell"
                >
                  <Box className="bigNumbersCellBox">
                    <Typography className="bigNumbersCellTitle">
                      Actual{metricsObject.suffix}
                    </Typography>
                    <Typography className="bigNumbersCellValue">
                      {metricsObject.actualValue}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell
                  onClick={helpMode ? null : handleClick}
                  id={
                    metricState == "hours"
                      ? "__dashboardProjectMetricsETCHours"
                      : "__dashboardProjectMetricsETCMoney"
                  }
                  className="bigNumbersCell"
                >
                  <Box className="bigNumbersCellBox">
                    <Typography className="bigNumbersCellTitle">
                      ETC{metricsObject.suffix}
                    </Typography>
                    <Typography className="bigNumbersCellValue">
                      {metricsObject.etcValue}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell
                  onClick={helpMode ? null : handleClick}
                  id={
                    metricState == "hours"
                      ? "__dashboardProjectMetricsEACHours"
                      : "__dashboardProjectMetricsEACMoney"
                  }
                  className="bigNumbersCell"
                >
                  <Box className="bigNumbersCellBox">
                    <Typography className="bigNumbersCellTitle">
                      EAC{metricsObject.suffix}
                    </Typography>
                    <Typography className="bigNumbersCellValue">
                      {metricsObject.eacValue}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell
                  onClick={helpMode ? null : handleClick}
                  id={
                    metricState == "hours"
                      ? "__dashboardProjectMetricsBudgetHours"
                      : "__dashboardProjectMetricsBudgetMoney"
                  }
                  className="bigNumbersCell"
                >
                  <Box className="bigNumbersCellBox">
                    <Typography className="bigNumbersCellTitle">
                      Budget{metricsObject.suffix}
                    </Typography>
                    <Typography className="bigNumbersCellValue">
                      {metricsObject.budgetValue}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell
                  onClick={helpMode ? null : handleClick}
                  id={
                    metricState == "hours"
                      ? "__dashboardProjectMetricsDiffHours"
                      : "__dashboardProjectMetricsDiffMoney"
                  }
                  className="bigNumbersCell"
                >
                  <Box className="bigNumbersCellBox">
                    <Typography className="bigNumbersCellTitle">
                      +/-{metricsObject.suffix}
                    </Typography>
                    <Typography className="bigNumbersCellValue">
                      {metricsObject.diffValue}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell
                  onClick={helpMode ? null : handlePctCompleteClick}
                  id={"__dashboardProjectMetricsPctComplete"}
                  className="bigNumbersCell"
                >
                  <Box className="bigNumbersCellBox">
                    <Typography className="bigNumbersCellTitle">
                      % Complete
                    </Typography>
                    {editPctComplete ? (
                      <input
                        ref={(inp) => (pctInput = inp)}
                        onBlur={savePctComplete}
                        type="text"
                        defaultValue={metricsObject.pctComplete}
                        style={{
                          fontSize: "34px",
                          width: "80px",
                          textAlign: "right",
                          borderRadius: "12px",
                          paddingRight: "10px",
                        }}
                      ></input>
                    ) : (
                      <Typography className="bigNumbersCellValue">
                        {metricsObject.pctComplete}
                      </Typography>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </>
    );
  }
}

export default DashboardProjectMetricsBigNumbers;
DashboardProjectMetricsBigNumbers.propTypes = {
  metric: PropTypes.string,
  projectObject: PropTypes.object,
  panelLocked: PropTypes.bool,
  removePanel: PropTypes.func,
  panelId: PropTypes.number,
  statusVersion: PropTypes.bool,
};
